export class Document {
    constructor(id, idClassName, className, path, fileName, deletedAt) {
        this.id = id;
        this.idClassName = idClassName;
        this.className = className;
        this.path = path;
        this.fileName = fileName;
        this.deletedAt = deletedAt;
    }

    static createFromResponseData(responseData) {
        return new Document(
            responseData.id,
            responseData.idClassName,
            responseData.className,
            responseData.path,
            responseData.fileName,
            responseData.deletedAt
        );
    }
}